export type GuestReminderValidationCode = 'required' | 'past';

type GuestReminderValidationValues = {
  channels: readonly string[];
  scheduledAt: Date | null;
};

export function validateGuestReminder(
  { channels, scheduledAt }: GuestReminderValidationValues,
  now: Date,
): GuestReminderValidationCode[] {
  const errors: GuestReminderValidationCode[] = [];

  if (channels.length === 0) {
    errors.push('required');
  }

  if (
    !scheduledAt ||
    !Number.isFinite(scheduledAt.getTime()) ||
    scheduledAt.getTime() <= now.getTime()
  ) {
    errors.push('past');
  }

  return errors;
}
